import Cover from './cover.jpeg'

export { Cover }
